import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
  IconButton,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Select,
  MenuItem,
  Grid,
  ButtonGroup,
  Tooltip,
  TextField,
  Button,
  TableSortLabel,
  Box,
  TableFooter,
} from "@mui/material";
import "./TableData.css";
import theme, { secundaryColor, contrastColor } from "../../config/theme";
import { Loader } from "rsuite";
import { Add, ChevronLeft, ChevronRight, Remove } from "@mui/icons-material";
import { visuallyHidden } from '@mui/utils';
import Images from "assets/images";
import Image from "./Image";
import { padding } from "@mui/system";
const SelectStyled = styled(Select)(() => ({
  minWidth: '250px',
  borderRadius: '8px',
  color: '#041C3F',
  height: '40px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#041C3F',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#041C3F',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#041C3F',
  },
}));
const TextFieldStyled = styled(TextField)(() => ({
  '& .MuiInputLabel-root': {
    color: '#041C3F',
  },
  '& .MuiInputBase-root': {
    borderRadius: '8px',
  },
  '& .MuiInputBase-input': {
    padding: '0px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#041C3F',
    borderWidth: '0px',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#041C3F',
    borderWidth: '0px',
  },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#041C3F',
    borderWidth: '0px',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: '#041C3F',
    borderWidth: '0px',
  },
}));
const TableData = ({
  dataTitle = [],
  dataRows = [],
  formatter = (data) => data,
  headerGroups = [],
  headerGroupOffset = 0,
  headerButtons,
  onChecked,
  onClick,
  onChange,
  actions,
  style,
  loading,
  filters,
  onChangePage = () => { },
  onChangeRowsPerPage = () => { },
  rowsPerPageOpt = 25,
  total,
  search = true,
  pagination = true,
  autonumber = true,
  headerStyle = {},
  title,
  onTitleClick,
  padding = '2px',
  sorteable = false,
  defaultOrder = 'desc',
  defaultOrderBy = null,
  dark = true,
  sorteableData
}) => {
  actions = actions?.filter(item => item)
  actions = actions?.length === 0 ? null : actions
  const [page, setPage] = useState(0);
  const [time, setTime] = useState(0);
  const [order, setOrder] = useState(defaultOrder);
  const [orderBy, setOrderBy] = useState(defaultOrderBy);
  const [lapsed, setLapsed] = useState(0)
  const [open, setOpen] = useState(null)
  const [open2, setOpen2] = useState(null)
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOpt);
  const StyledTableRow = styled(TableRow)(({ theme, collapsible }) => {
    return {
      "& td": {
        backgroundColor: collapsible && '#e4f6ff',
        border: 0
      },
      "&:nth-of-type(odd) td": {
        backgroundColor: collapsible && '#d7e9f3',
      },
      "&:nth-of-type(odd)": {
        backgroundColor: '#FFFFFF',
      },
      "&:last-child td, &:last-child th": {
        border: 0,
      },
    };
  });
  const StyledTableRow2 = styled(TableRow)(({ theme, collapsible }) => {
    return {
      "& td": {
        backgroundColor: collapsible && '#fffee4',
      },
      "&:nth-of-type(odd) td": {
        backgroundColor: collapsible && '#f0f3d7',
      },
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.grey[300],
      },
      "&:last-child td, &:last-child th": {
        border: 0,
      },
    };
  });

  useEffect(() => {
    if (loading) {
      setTime(new Date().getTime())
      setLapsed(0)
    } else {
      setLapsed(time !== 0 ? new Date().getTime() - time : 0)
      setTime(0)
    }
  }, [loading]);

  useEffect(() => {
    if (!total) {
      setPage(0);
      onChangePage(0, rowsPerPage)
      onChangeRowsPerPage(rowsPerPage)
    }
  }, [dataRows.length]);

  useEffect(() => {
    setPage(0);
    onChangePage(0, rowsPerPage)
    onChangeRowsPerPage(rowsPerPage)
  }, [filters]);


  const handlerChangePage = (e, newPage) => {
    setPage(newPage);
    onChangePage(newPage, rowsPerPage);
  };

  const handlerChangeRowsPerPage = (e) => {
    setRowsPerPage(e.target.value);
    onChangeRowsPerPage(e.target.value)
    setPage(0);
    onChangePage(0, e.target.value);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(() => {
    if (sorteable)
      dataRows = sorteableData(dataRows).sort(getComparator(order, `_${orderBy}_`))
    return total ? dataRows : dataRows.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage,
    )
  },
    [dataRows, page, rowsPerPage, orderBy, order],
  );

  return (
    <div className="wrapper-table">
      {
        search && (
          <Grid container columnSpacing={2} mb={2} justifyContent={"flex-end"}>
            {headerButtons &&
              <ButtonGroup variant="outlined" aria-label="outlined primary button group" sx={{
                gap: 2,
                '& .MuiButtonGroup-grouped': {
                  borderRadius: 25,
                },
                '& .MuiButtonGroup-firstButton': {
                  borderRadius: 25,
                  '&:hover': {
                    borderRightColor: secundaryColor,
                  }
                },
                '& .MuiButtonGroup-lastButton': { borderRadius: 25 },
              }}>
                {headerButtons.map((component) => component)}
              </ButtonGroup>
            }
          </Grid>
        )
      }

      <TableContainer  >
        <Table
          stickyHeader
          // sx={{ minWidth: 650 }}
          size="small"
          aria-label="simple table"
          classes={{ root: 'table-data' }}
        >
          <TableHead>
            {
              title && (
                <TableRow >
                  <TableCell
                    onClick={(e) => onTitleClick && onTitleClick(e)}
                    sx={{
                      fontWeight: 'bold',
                      backgroundColor: secundaryColor,
                      color: '#ffffff',
                      textAlign: 'center',
                      fontSize: '20px',
                      cursor: onTitleClick ? 'pointer' : 'default',
                      height: 30,
                      borderTopRightRadius: 8,
                      borderTopLeftRadius: 8,
                      borderBottom: 0,
                    }}
                    colSpan={dataTitle.length + (autonumber ? 1 : 0) + (actions ? 1 : 0)} >
                    {title}
                  </TableCell>
                </TableRow>
              )
            }
              {
                headerGroups.length > 0 && (
                  <TableRow>
                    <TableCell
                      sx={{
                        fontWeight: 'bold',
                        backgroundColor: title ? contrastColor : dark ? secundaryColor : contrastColor,
                        color: title ? '#02060' : dark ? '#ffffff' : '#02060',
                        textAlign: 'center',
                        fontSize: '16px',
                        border: 0,
                      }}
                      colSpan={headerGroupOffset + ((visibleRows.some(item => item.collapsible) ? 1 : 0)) + (!dataTitle.map(item => item.label || item).includes('Id') && autonumber ? 1 : 0)}
                    />
                    {
                      headerGroups.map(({ label, colSpan }, index) => (
                        <TableCell
                          key={`${label}_${index}`}
                          sx={{
                            fontWeight: 'bold',
                            backgroundColor: title ? contrastColor : dark ? secundaryColor : contrastColor,
                            color: title ? '#02060' : dark ? '#ffffff' : '#02060',
                            textAlign: 'center',
                            fontSize: '16px',
                            border: 0,
                          }}
                          colSpan={colSpan}
                        >
                          {label}
                        </TableCell>
                      ))
                    }
                    {
                      actions && (
                        <TableCell
                          sx={{
                            fontWeight: 'bold',
                            backgroundColor: title ? contrastColor : dark ? secundaryColor : contrastColor,
                            color: title ? '#02060' : dark ? '#ffffff' : '#02060',
                            textAlign: 'center',
                            fontSize: '16px',
                            border: 0,
                          }}
                        />
                      )
                    }
                  </TableRow>
                )
              }
            <TableRow className={`table-row${title ? '' : '-header'}`} >
              {
                visibleRows.some(item => item.collapsible) && (
                  <TableCell
                    sx={{
                      fontWeight: 'bold',
                      backgroundColor: title ? contrastColor : dark ? secundaryColor : contrastColor,
                      color: title ? '#02060' : dark ? '#ffffff' : '#02060',
                      textAlign: 'center',
                      width: 10,
                      border: 0
                    }}
                  />
                )
              }
              {
                !dataTitle.map(item => item.label || item).includes('Id') && autonumber && (
                  <TableCell
                    sx={{
                      fontWeight: 'bold',
                      backgroundColor: title ? contrastColor : dark ? secundaryColor : contrastColor,
                      color: title ? '#02060' : dark ? '#ffffff' : '#02060',
                      textAlign: 'center',
                      width: 10,
                      fontSize: '16px',
                      border: 0
                    }}
                  />
                )
              }
              {
                dataTitle.map((item, h) => (
                  <TableCell
                    sx={{
                      fontWeight: 'bold',
                      backgroundColor: title ? contrastColor : dark ? secundaryColor : contrastColor,
                      color: title ? '#02060' : dark ? '#ffffff' : '#02060',
                      textAlign: 'center',
                      fontSize: '16px',
                      ...headerStyle
                    }}
                    key={h + "title"}
                  // sortDirection={orderBy === title ? order : false}
                  >
                    {
                      sorteable ? (
                        <TableSortLabel
                          active={orderBy === item.name}
                          direction={orderBy === item.name ? order : 'asc'}
                          onClick={() => handleRequestSort(item.name)}
                        >
                          {item.label}
                          {orderBy === item.name ? (
                            <Box component="span" sx={visuallyHidden}>
                              {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                          ) : null}
                        </TableSortLabel>
                      ) : item.label || item
                    }
                  </TableCell>
                ))
              }
              {actions && <TableCell sx={{
                fontWeight: 'bold',
                backgroundColor: title ? contrastColor : dark ? secundaryColor : contrastColor,
                color: title ? '#02060' : dark ? '#ffffff' : '#02060',
                textAlign: 'center',
                fontSize: '16px',
              }} >Acciones</TableCell>}
            </TableRow>
          </TableHead>
          <TableBody>
            {
              loading ? (
                <TableRow>
                  <TableCell colSpan={dataTitle.length + (autonumber ? 1 : 0) + (actions ? 1 : 0)} style={{ textAlign: 'center' }}>
                    <Loader size="md" />
                  </TableCell>
                </TableRow>
              ) :
                visibleRows.map((item, i) => (
                  <>
                    <StyledTableRow
                      key={i + "row"}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "& td": {
                          padding,
                          ...item.style
                        }
                      }}
                    >
                      {
                        item.collapsible ? (
                          <TableCell>
                            <IconButton
                              aria-label="expand row"
                              size="small"
                              onClick={() => setOpen(open === i ? null : i)}
                              sx={{
                                p: 0
                              }}
                            >
                              {open === i ? <Remove /> : <Add />}
                            </IconButton>
                          </TableCell>
                        ) : (
                          visibleRows.some(item => item.collapsible) ? <TableCell sx={{ textAlign: 'center' }}></TableCell> : null
                        )
                      }
                      {
                        !dataTitle.map(item => item.label || item).includes('Id') && autonumber && <TableCellFormatter value={total ? (page * rowsPerPage) + i + 1 : i + 1} />
                      }
                      {
                        formatter(item, i).map((value, key) => {
                          return <TableCellFormatter
                            key={key + "cell"}
                            data={item}
                            value={value}
                            onChecked={onChecked}
                            onChange={onChange}
                          />
                        })
                      }
                      {
                        actions && (
                          <TableCellActions data={item} actions={actions} />
                        )
                      }
                    </StyledTableRow>
                    {
                      item.collapsible && open == i && item.collapsible.map((row, i) => (
                        <>
                          <StyledTableRow key={i + "collapsible"} collapsible>
                            {
                              row.collapsible ? (
                                <TableCell>
                                  <IconButton
                                    aria-label="expand row"
                                    size="small"
                                    onClick={() => setOpen2(open2 === i ? null : i)}
                                  >
                                    {open2 === i ? <Remove /> : <Add />}
                                  </IconButton>
                                </TableCell>
                              ) : (
                                visibleRows.some(item => item.collapsible) ? <TableCell sx={{ textAlign: 'center' }}></TableCell> : null
                              )
                            }
                            {
                              !dataTitle.map(item => item.label || item).includes('Id') && autonumber && <TableCellFormatter value={i + 1} />
                            }
                            {
                              formatter(row, i).map((value, key) => {
                                return <TableCellFormatter
                                  key={key + "cell"}
                                  data={row}
                                  value={value}
                                  onChecked={onChecked}
                                  onChange={onChange}
                                />
                              })
                            }
                            {
                              actions && (
                                <TableCellActions data={row} actions={actions} />
                              )
                            }
                          </StyledTableRow>
                          {
                            row.collapsible && open2 == i && row.collapsible.map((row, i) => (
                              <StyledTableRow2 key={i + "collapsible"} collapsible>
                                <TableCell
                                  sx={{
                                    width: 0,
                                    border: 0
                                  }}
                                />
                                {
                                  !dataTitle.map(item => item.label || item).includes('Id') && autonumber && <TableCellFormatter value={i + 1} />
                                }
                                {
                                  formatter(row, i).map((value, key) => {
                                    return <TableCellFormatter
                                      key={key + "cell"}
                                      data={row}
                                      value={value}
                                      onChecked={onChecked}
                                      onChange={onChange}
                                    />
                                  })
                                }
                                {
                                  actions && (
                                    <TableCellActions data={row} actions={actions} />
                                  )
                                }
                              </StyledTableRow2>
                            ))
                          }
                        </>
                      ))
                    }
                  </>
                ))
            }
          </TableBody>
          <TableFooter>
            <TableRow >
              <TableCell
                sx={{
                  backgroundColor: contrastColor,
                  borderBottomRightRadius: 8,
                  borderBottomLeftRadius: 8,
                  borderBottom: 0,
                }}
                colSpan={dataTitle.length + (autonumber ? 1 : 0) + (actions ? 1 : 0)}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      <Grid container justifyContent={"space-between"}>
        <Grid item>
          {lapsed != 0 && <div style={{
            color: theme.contrastColor,
            fontSize: 14,
            marginTop: 16,
            fontWeight: 400,
            // position: 'absolute',
          }}>Tiempo de búsqueda: {lapsed / 1000} s</div>}
        </Grid>
        <Grid item>
          {
            pagination && (
              <TablePagination

                rowsPerPageOptions={dataRows.length === 0 ? [] : [15, 25, 50, 100, 200, 500]}
                component="div"
                count={total || dataRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handlerChangePage}
                onRowsPerPageChange={handlerChangeRowsPerPage}
                labelDisplayedRows={({ from, to, count, page }) => `${page + 1}/${Math.ceil(count / rowsPerPage)} página (${count} registros)`}
                labelRowsPerPage={dataRows.length === 0 ? '' : "Filas por página:"}
                slots={{
                  actions: {
                    previousButton,
                    nextButton,
                  }
                }}
              />
            )
          }
        </Grid>
        <Grid item></Grid>
      </Grid>
    </div>
  );
};

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const TableCellFormatter = ({ value, data, onChecked }) => {
  if (value === null)
    return <TableCell sx={{ textAlign: 'center' }}></TableCell>
  if (typeof value === 'object') {
    if (value.type === 'custom')
      return (
        <TableCell sx={{ textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
          {value.value}
        </TableCell>
      );
    if (value.type === 'boolean')
      return (
        <TableCellBoolean
          value={value.value}
          data={data}
          onChecked={onChecked || value.onChange}
          col={value.name}
          disabled={value.disabled}
          uncheckedGray={value.uncheckedGray}
        />
      );
    else if (value.type === 'img')
      return (
        <TableCellImage
          value={value.value}
          title={value.title}
        />
      );
    else if (value.type === 'button')
      return (
        <TableCellButton
          data={data}
          value={value.value}
          onClick={value.action}
          title={value.title}
        />
      );
    else if (value.type === 'select_button')
      return (
        <TableCellSelectButton
          list={value.list}
          value={value.value}
          data={data}
          label={value.label}
          disabled={value.disabled}
          onChange={value.onChange}
        />
      );
    else if (value.type === 'input')
      return (
        <TableCellInput
          value={value.value}
          data={data}
          onChange={value.onChange}
          disabled={value.disabled}
          onBlur={value.onBlur}
          onEnter={value.onEnter}
          render={value.render}
        />
      );
    else if (value.type === 'text')
      return <TableCell
        sx={{
          textAlign: 'center',
          whiteSpace: "nowrap",
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          maxWidth: value.maxWidth,
        }}
        title={value.title || value.value}
        onClick={(e) => e.stopPropagation()}
      >
        {value.value}
      </TableCell>;
    else
      return <TableCell sx={{ textAlign: 'center' }} onClick={(e) => e.stopPropagation()} >{value}</TableCell>;
  }
  else
    return <TableCell sx={{ textAlign: 'center', padding: 0 }} onClick={(e) => e.stopPropagation()} >{value}</TableCell>;
};

const TableCellBoolean = ({ value, data, onChecked, col, disabled, uncheckedGray }) => {

  return (
    <TableCell
      sx={{ height: 'auto', textAlign: 'center' }}
    >
      <Checkbox
        className="btn-action"
        checked={value}
        checkedIcon={<Image src={Images.icon.check_square} />}
        icon={<Image src={Images.icon.uncheck_square} style={uncheckedGray ? { opacity: 0.35, filter: 'grayscale(1)' } : undefined} />}
        onChange={() => onChecked(data, value, col)}
        inputProps={{ "aria-label": "controlled" }}
        disabled={disabled}
        sx={{ padding: 0 }}
      />
    </TableCell>
  );
};

const TableCellImage = ({ value, title = "" }) => {
  return (
    <TableCell sx={{ textAlign: 'center', height: 25 }}>
      {
        typeof value === 'string' ? (
          <img alt={title} src={value} height={25} title={title} />
        ) : <div title={title} style={{cursor: 'pointer'}}>{value}</div>
      }
    </TableCell>
  );
};

const TableCellButton = ({ data, value, onClick, title= "Ver" }) => {
  return (
    <TableCell sx={{ textAlign: 'center' }}>
      <IconButton
        title={title}
        aria-label="view"
        onClick={() => onClick(data)}
        size="small"
        sx={{ padding: 0 }}
      >
        {value}
      </IconButton>
    </TableCell>
  );
};
const TableCellInput = ({ data, value, disabled, onChange, onBlur, onEnter, render }) => {
  const [val, setVal] = useState(value)
  const [focused, setFocused] = useState(false)
  return (
    <TableCell sx={{ textAlign: 'center' }}>
      <TextFieldStyled
        value={focused ? val : render ? render(val) : val}
        size="small"
        inputProps={{
          style: {
            textAlign: 'center'
          }
        }}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => {
          setVal(e.target.value)
          onChange && onChange(e.target.value, data)
        }}
        disabled={disabled}
        onFocus={() => setFocused(true)}
        onBlur={() => {
          setFocused(false);
          onBlur(val, data);
        }}
        render={render}
        onKeyPress={(e) => {
          if (e.key === 'Enter') {
            onEnter(val, data)
          }
        }}
      />
    </TableCell>
  );
};

const TableCellSelectButton = ({ data, list, value, label, disabled, onChange }) => {
  return (
    <TableCell sx={{ textAlign: 'center' }}>
      {/* <FormControl sx={{ p: 0, m: 0, minWidth: 200 }} size="small"> */}
      <SelectStyled
        className="table-cell-select"
        value={value || ''}
        onChange={(e) => {
          onChange(e.target.value, data)
        }}
        disabled={disabled}
        // label={label}
        sx={{ padding: 0 }}
      >
        {list.map((item, i) => (
          <MenuItem
            key={"item_" + item.name + i}
            value={item.id}
            sx={{
              '&.MuiMenuItem-root': {
                paddingY: 0
              }
            }}>
            {item.name}
          </MenuItem>
        ))}
      </SelectStyled>
      {/* </FormControl> */}
    </TableCell>
  );
};

const TableCellActions = ({ data, actions }) => {
  return (
    <TableCell sx={{ textAlign: 'center', verticalAlign: 'middle' }}>
      <ButtonGroup variant="text" aria-label="outlined primary button group" >
        {
          actions.map((action) => {
            const add = action.validate ? action.validate(data) : true;
            return add ? action : { empty: true };
          }).map(({ icon, label, onClick, empty }, i) => (
            empty ? <Box sx={{ width: 24, height: 10 }} /> : <Tooltip
              key={i}
              title={label}
              arrow
            >
              <Button
                id={label + data.username}
                variant="text"
                // startIcon={icon}
                size="small"
                onClick={() => onClick(data)}
                className="btn-action"
              >
                {typeof icon == 'function' ? icon(data) : icon}
              </Button>
            </Tooltip>
          ))
        }
      </ButtonGroup>
    </TableCell>
  );
};

export default TableData;


const nextButton = (props) => {
  return (
    <IconButton {...props} sx={{
      backgroundColor: theme.button.dark.backgroundColor,
      color: theme.button.dark.color,
      height: '30px',
      width: '30px',
      marginLeft: 1,
      '&:hover': {
        backgroundColor: theme.button.dark.backgroundColor,
        opacity: 0.8,
      },
    }}>
      <ChevronRight />
    </IconButton>
  );
}
const previousButton = (props) => {
  return (
    <IconButton {...props} sx={{
      backgroundColor: theme.button.dark.backgroundColor,
      color: theme.button.dark.color,
      height: '30px',
      width: '30px',
      marginRight: 1,
      '&:hover': {
        backgroundColor: theme.button.dark.backgroundColor,
        opacity: 0.8,
      },
    }}>
      <ChevronLeft />
    </IconButton>
  );
}